// eslint-disable-next-line
export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Toolbar.components.ToolbarDesks.External'

export const EXTERNAL_LINKS = {
    items: {
        CZ: ['orcz', 'insolvence', 'aresres', 'aresor', 'aresrzp', 'aresdph', 'skdph', 'google'],
        SK: ['orsk', 'ruzsk', 'knsk', 'crzsk', 'rzpsk', 'aresdph', 'skdph', 'obsk', 'edb', 'google'],
        other: ['google'],
    },
    links: {
        items: [
            { key: 'orcz', url: 'https://or.justice.cz/ias/ui/rejstrik-$firma?jenPlatne=VSECHNY&ico={regNbr}' },
            {
                key: 'insolvence',
                url: 'https://isir.justice.cz/isir/ueu/vysledek_lustrace.do?aktualnost=AKTUALNI_I_UKONCENA&ic={regNbr}',
            },
            {
                key: 'aresres',
                url: 'https://ares.gov.cz/ekonomicke-subjekty/res/{regNbr}',
            },
            { key: 'aresor', url: 'https://or.justice.cz/ias/ui/rejstrik-$firma?ico={regNbr}&jenPlatne=VSECHNY' },
            {
                key: 'aresrzp',
                url: 'https://www.rzp.cz/verejne-udaje/cs/udaje/vyber-subjektu;ico={regNbr};roleSubjektu=P',
            },
            { key: 'aresdph', url: 'http://adisreg.mfcr.cz/adistc/DphReg', withoutPostfix: true },
            {
                key: 'skdph',
                url: 'https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/zoznamy/detail/_b6188880-e315-47f0-895d-a275008afcf2',
                withoutPostfix: true,
            }, // eslint-disable-line
            {
                key: 'obsk',
                url: 'https://www.justice.gov.sk/PortalApp/ObchodnyVestnik/Formular/FormulareZverejnene.aspx',
                withoutPostfix: true,
            },
            { key: 'orsk', url: 'http://orsr.sk/hladaj_ico.asp?ICO={regNbr}' },
            {
                key: 'ruzsk',
                url: 'http://www.registeruz.sk/cruz-public/domain/accountingentity/search?name=&entNumber={regNbr}',
            },
            { key: 'knsk', url: 'http://www.katasterportal.sk/kapor/vyhladavanieVlastnikFormInit.do?ico={regNbr}' },
            { key: 'crzsk', url: 'http://www.crz.gov.sk/index.php?ID=114395&search={regNbr}' },
            {
                key: 'rzpsk',
                url: 'https://www.notar.sk/zalozne-prava/?debtorIdentifier={regNbr}',
            },
            { key: 'edb', url: 'http://www.edb.sk/{selectedLanguage}/firmy/-S0{regNbr}000.html' },
            { key: 'google', url: 'https://www.google.com/?gws_rd=ssl#hl={selectedLanguage}&q={regNbr}' },
        ],
        postfix: '&utm_source=app.gnosus.cz&utm_medium=external-links&utm_campaign=app.gnosus.cz',
    },
}
